import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

import Button, { TYPES } from 'components/Button';
import Input from 'components/Input';
import Paragraph from 'components/Paragraph';
import { Sub } from 'components/Sub';
import { mediumUp } from 'constants/mediaQueries';
import Theme from 'styles/theme';
import I18n from 'utils/I18n';
import Validator from 'utils/Validator';

class StayInTouchEmailSignUpForm extends PureComponent {
  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      email: '',
      isValid: null,
      hasSubmittedSignUpRequest: false,
    };
  }

  handleSubmit = event => {
    event.preventDefault();

    const { email } = this.state;
    const isValid = Validator.isEmail(email);

    this.setState(() => ({ isValid }));

    if (isValid) {
      this.setState(() => ({ hasSubmittedSignUpRequest: true }));
      this.props.onSubmit({
        emailAddress: email,
        acceptsMarketing: true,
        origination: 'stayInTouch',
      });
    }
  };

  handleBlur = () => {
    this.setState(() => ({ isValid: null }));
  };

  handleChange = event => {
    const email = event.target.value;

    this.setState(() => ({ email }));
  };

  render() {
    const { hasSubmittedSignUpRequest } = this.state;
    const emailSignUplabel = I18n.localize('footer.emailSignUpLabel');
    const emailSignUpSubmitButtonText = I18n.localize('footer.emailSignUpSubmitButtonText');
    const emailSignUpErrorText = I18n.localize('footer.emailSignUpErrorText');
    const emailSignUpSuccessText = I18n.localize('footer.emailSignUpSuccessText');

    return (
      <div className="StayInTouchEmailSignUpForm">
        {hasSubmittedSignUpRequest ? (
          <Paragraph>{emailSignUpSuccessText}</Paragraph>
        ) : (
          <div className="StayInTouchEmailSignUpForm__form-container">
            <form className="StayInTouchEmailSignUpForm__form" onSubmit={this.handleSubmit}>
              <div className="StayInTouchEmailSignUpForm__row">
                <div className="StayInTouchEmailSignUpForm__input-cell">
                  <div className="StayInTouchEmailSignUpForm__input-container">
                    <Input
                      inputType="text"
                      id="StayInTouchEmailSignUpForm__input"
                      isValid={this.state.isValid}
                      onChange={this.handleChange}
                      onBlur={this.handleBlur}
                      ariaLabel={emailSignUplabel}
                    />

                    {this.state.isValid === false && (
                      <div className="StayInTouchEmailSignUpForm__error-text">
                        <Sub>{emailSignUpErrorText}</Sub>
                      </div>
                    )}
                  </div>
                </div>

                <div className="StayInTouchEmailSignUpForm__button-cell">
                  <Button
                    isSubmit
                    isFullWidth
                    type={TYPES.DARK_GRAY}
                    id="StayInTouchEmailSignUpForm__submit-button"
                  >
                    {emailSignUpSubmitButtonText}
                  </Button>
                </div>
              </div>
            </form>
          </div>
        )}

        <style jsx>
          {`
            .StayInTouchEmailSignUpForm__input-cell {
              margin-bottom: ${Theme.get('spacing') * 4}px;
            }

            .StayInTouchEmailSignUpForm__input-container {
              margin-bottom: ${Theme.get('spacing') * 3}px;
            }

            .StayInTouchEmailSignUpForm__label-container {
              margin-bottom: ${Theme.get('spacing-px')};
            }

            .StayInTouchEmailSignUpForm__error-text {
              margin-top: ${Theme.get('spacing-px')};
            }

            @media ${mediumUp} {
              .StayInTouchEmailSignUpForm__row {
                display: flex;
                align-items: flex-start;
                width: 100%;
              }

              .StayInTouchEmailSignUpForm__input-cell {
                margin-right: ${Theme.get('spacing-px')};
                margin-bottom: 0;
                width: 70%;
              }

              .StayInTouchEmailSignUpForm__button-cell {
                margin-left: ${Theme.get('spacing-px')};
                width: 30%;
              }
            }
          `}
        </style>
      </div>
    );
  }
}

export default StayInTouchEmailSignUpForm;
